<template>
  <div>
    <div class="part" :style="partNameStyleObject">
      <div class="part_name">{{ decoration_part.label || decoration_part.name }}</div>
      <div class="color_name">{{ selectedColor.name }}</div>
    </div>
    <colors :selectedColor="selectedColor" :colors="selectedDecoration.color_group.colors" @setColor="setColor"></colors>
  </div>
</template>

<script>
  import Colors from './parts/Colors.vue'
  import _ from 'underscore'
  export default {
    name: 'part',
    components: {
      Colors
    },
    props: ['decoration_part', 'selectedLetter', 'selectedDecoration'],
    data(){
      return {
        selectedColor: null
      }
    },
    computed: {
      partNameStyleObject(){
        if (this.selectedColor) {
          return {
            borderLeft: '6px solid ' + ((this.selectedColor.color) ? this.selectedColor.color : 'transparent')
          }
        }
      }
    },
    methods: {
      setColor(color){
        this.selectedColor = color;
        this.$store.commit('setCartLetterColor', {
          selectedLetter: this.selectedLetter,
          decoration_part: this.decoration_part,
          color: color
        });
      },
    },
    created(){
      this.selectedColor = _.find(this.selectedDecoration.color_group.colors, {id: this.selectedDecoration.color_id});
    }
  }
</script>


<style scoped>
  .label{
    display: flex;
    align-items: center;
    position: absolute;
    background-color: #fff;
    background-image: linear-gradient(#ffffff 90%, #c0c0c0);
    box-shadow: 3px 0 6px 0 rgba(0,0,0,0.4);
    width: 100px;
    height: 50px;
    float:left;
    border-bottom: 1px solid gray;
    border-right: 1px solid gray;
    vertical-align: middle;
    box-sizing: border-box;
    padding: 4px;
    z-index:2;
  }
  .part {
    /*display: flex;*/
    align-items: center;
    position: absolute;
    background-color: #fff;
    background-image: linear-gradient(#ffffff 90%, #c0c0c0);
    box-shadow: 3px 0 6px 0 rgba(0,0,0,0.4);
    width: 100px;
    height: 50px;
    float:left;
    border-bottom: 1px solid gray;
    border-right: 1px solid gray;
    vertical-align: middle;
    box-sizing: border-box;
    padding: 4px;
    z-index:2;
    line-height: 1.5rem;
  }
  .part .color_name{
    overflow: hidden;
    white-space: nowrap;
  }
</style>
